import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { AnimatePresence } from 'framer-motion';
import { useHeroDetailStore } from '../stores/heroDetail';
import { HeroDetail } from './HeroDetail';

// The single mount point for the hero lightbox — the sibling of
// CardDetailHost, and deliberately a copy of it rather than a shared
// abstraction. The whole body is five lines of navigation bookkeeping; a
// shared host would have to take the store, the component and the key as
// parameters, which is more moving parts than the duplication costs. If a
// third lightbox ever appears, that is the moment to extract one.
//
// The same two constraints as the card host apply and are the reason it
// looks like this:
//   - AnimatePresence lives HERE, not inside HeroDetail. That component
//     unmounts the instant the store clears, so an AnimatePresence inside it
//     could never run its own exit.
//   - The host sits OUTSIDE RouteLayout's route-crossfade tree, which would
//     otherwise unmount it on every navigation and cut the exit short. The
//     trade is that a lightbox left open across a route change would survive
//     into a screen that has moved on, so close it on pathname change.

export function HeroDetailHost() {
  const hero = useHeroDetailStore((s) => s.hero);
  const close = useHeroDetailStore((s) => s.close);
  const { pathname } = useLocation();

  useEffect(() => {
    // Reads through getState so this fires only on real navigations, not
    // every time the inspected hero changes.
    if (useHeroDetailStore.getState().hero !== null) close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <AnimatePresence>
      {hero && <HeroDetail key={hero.id} hero={hero} onClose={close} />}
    </AnimatePresence>
  );
}
